import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs/Observable";
import { SoundProfileResponse } from "../types/sound-profile-response";

@Injectable({
  providedIn: "root",
})
export class SoundProfileService {
  constructor(private httpClient: HttpClient) {}

  getSoundProfile(userId, parentSoundProfileId) {
    return this.httpClient.post<SoundProfileResponse>(
      "servlets/soundprofile/",
      {
        userId,
        parentSoundProfileId,
      }
    );
  }

  getSoundProfileWithAdaptive(userId, parentSoundProfileId) {
     return this.httpClient.post<SoundProfileResponse>(
            "servlets/soundprofile/adaptive/",
            {
                userId,
                parentSoundProfileId,
        }
     );
  }


  addUpdateSoundProfile(userId, soundProfiles): Observable<any> {
    return this.httpClient.put("servlets/soundprofile/", {
      userId,
      soundProfiles,
    });
  }

  getParentProfiles(): Observable<any> {
    return this.httpClient.get("servlets/soundprofile/parentprofile/");
  }

  addParentSoundProfileId(userId, parentProfileId): Observable<any> {
    return this.httpClient.put("servlets/soundprofile/parentprofile/", {
      userId,
      parentProfileId,
    });
  }

  scanAR2VoiceTemplates(userId: number, userName: string){
    return this.httpClient.post<SoundProfileResponse>("servlets/soundprofile/scanAR2/", {
      userId,
      userName,
    });
  }
}
